import { useEffect, useRef } from "react";

// MediaQueryList Event based useEventListener interface
// function useEventListener<K extends keyof MediaQueryListEventMap>(
//   eventName: K,
//   handler: (event: MediaQueryListEventMap[K]) => void,
//   element: RefObject<MediaQueryList>,
//   options?: boolean | AddEventListenerOptions,
// ): void;

// // Window Event based useEventListener interface
// function useEventListener<K extends keyof WindowEventMap>(
//   eventName: K,
//   handler: (event: WindowEventMap[K]) => void,
//   element?: undefined,
//   options?: boolean | AddEventListenerOptions,
// ): void;

// // Element Event based useEventListener interface
// function useEventListener<
//   K extends keyof HTMLElementEventMap,
//   T extends HTMLElement = HTMLDivElement,
// >(
//   eventName: K,
//   handler: (event: HTMLElementEventMap[K]) => void,
//   element: RefObject<T>,
//   options?: boolean | AddEventListenerOptions,
// ): void;

// // Document Event based useEventListener interface
// function useEventListener<K extends keyof DocumentEventMap>(
//   eventName: K,
//   handler: (event: DocumentEventMap[K]) => void,
//   element: RefObject<Document>,
//   options?: boolean | AddEventListenerOptions,
// ): void;

/*
const useEventListener = <
  KW extends keyof WindowEventMap,
  KH extends keyof HTMLElementEventMap,
  KM extends keyof MediaQueryListEventMap,
  T extends HTMLElement | MediaQueryList = HTMLElement,
>(
  eventName: KW | KH | KM,
  handler: (
    event:
      | WindowEventMap[KW]
      | HTMLElementEventMap[KH]
      | MediaQueryListEventMap[KM]
      | Event,
  ) => void,
  element?: React.RefObject<T>,
  options?: boolean | AddEventListenerOptions,
) 

*/

const useEventListener = (eventName, handler, element, options) => {
  // Create a ref that stores handler
  //   const savedHandler = useRef<typeof handler>();
  const savedHandler = useRef();

  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(() => {
    // Define the listening target
    // const targetElement: T | Window = element?.current ?? window;
    const targetElement = element?.current ?? window;

    if (!(targetElement && targetElement.addEventListener)) return;

    // Create event listener that calls handler function stored in ref

    /*
    const eventListener: typeof handler = (event) => {
      savedHandler.current?.(event);
    };
    */
    const eventListener = (event) => {
      savedHandler.current?.(event);
    };

    // Add event listener
    targetElement.addEventListener(eventName, eventListener, options);

    // Remove event listener on cleanup
    // eslint-disable-next-line consistent-return
    return () => {
      targetElement.removeEventListener(eventName, eventListener, options);
    };
  }, [element, eventName, options]);
};

export default useEventListener;
